import axios from 'axios';

export class MTSProvider {
    constructor(protected path: string) {}

    loadDelivery = async (params: Record<string, string | undefined>) => {
        try {
            const url = `${this.path}/mts/delivery/`;
            const { data } = await axios.get<{ dates: Array<string>; intervals: Array<string> }>(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                params,
            });
            return data;
        } catch (e) {
            console.log(e);
            return null;
        }
    };
}
